import React from "react"
import PropTypes from "prop-types"
import { withRadium } from "higher-order-components"
import { BASE_COPY } from "constants/general-style"
import COLOR_PALETTE from "constants/color-palette"

const PaginationSelector = ({
  count = 0,
  current = 0,
  maxDisplay = 3,
  onClickNumber = () => {},
  onClickNext = () => {},
  onClickBack = () => {}
}) => {
  const workingDisplay = maxDisplay - 2
  const min = Math.floor((current - 1) / workingDisplay) * workingDisplay
  const max = min + workingDisplay
  const leftSlice = min - 1
  const rightSlice = max + 1
  const pageNumbers = Array(count)
    .fill()
    .map((v, index) => index + 1)
    .slice(leftSlice < 0 ? 0 : leftSlice, rightSlice)
  const showPrev = current > 1
  const showNext = current < count
  return (
    <div>
      {showPrev && (
        <button
          key={"back"}
          onClick={onClickBack}
          style={[styles.link, styles.inactive, { padding: "0 0 0 1em" }]}
          tabIndex={0}>
          {"< PREV"}
        </button>
      )}
      {pageNumbers.map(pageNumber => (
        <div key={pageNumber} style={styles.number}>
          <button
            key={`goto_${pageNumber}`}
            onClick={() => onClickNumber(pageNumber)}
            tabIndex={0}
            style={[styles.link, pageNumber === current ? styles.active : styles.inactive]}>
            {pageNumber}
          </button>
          <div style={styles.line} />
        </div>
      ))}
      {showNext && (
        <button
          key={"next"}
          onClick={onClickNext}
          style={[styles.link, styles.inactive]}
          tabIndex={0}>
          {"NEXT >"}
        </button>
      )}
    </div>
  )
}

PaginationSelector.propTypes = {
  count: PropTypes.number,
  current: PropTypes.number,
  maxDisplay: PropTypes.number,
  onClickNumber: PropTypes.func,
  onClickNext: PropTypes.func,
  onClickBack: PropTypes.func
}

const styles = {
  wrapper: {
    display: "inline-block",
    fontSize: "90%"
  },
  line: {
    borderRight: `1px ${COLOR_PALETTE.GRAY_DARK} solid`,
    marginBottom: "0.14em"
  },
  inactive: {
    color: COLOR_PALETTE.GRAY_DARK
  },
  active: {
    color: COLOR_PALETTE.BLACK
  },
  link: {
    ...BASE_COPY,
    margin: "0",
    outline: "none",
    textAlign: "inherit",
    fontFamily: "inherit",
    overflow: "visible",
    background: "none",
    border: "none",
    padding: "0 1em",
    fontWeight: "400",
    lineHeight: "1.1",
    cursor: "pointer",
    transition: "color .25s",
    ":hover": {
      color: COLOR_PALETTE.BLACK,
      textDecoration: "underline"
    },
    ":focus": {
      outline: 0
    }
  },
  number: {
    display: "inline-flex"
  }
}

PaginationSelector.propTypes = {}

export default withRadium()(PaginationSelector)



// WEBPACK FOOTER //
// ./src/components/pagination-selector/index.jsx